import { useMobile } from "@/hooks/use-mobile";
import MobileLayout from "@/components/layout/MobileLayout";
import DesktopLayout from "@/components/layout/DesktopLayout";
import { Outlet, useMatches } from "react-router-dom";

type RouteHandle = {
  hideTopHero?: boolean;
};

export default function ResponsiveLayout() {
  const isMobile = useMobile();
  const matches = useMatches();

  // A page opts out of the top hero via its route `handle: { hideTopHero: true }`
  const showTopHero = !matches.some(
    (match) => (match.handle as RouteHandle | undefined)?.hideTopHero,
  );

  const Layout = isMobile ? MobileLayout : DesktopLayout;

  return (
    <Layout showTopHero={showTopHero}>
      <Outlet />
    </Layout>
  );
}
